import React from 'react';

import { Drawer } from './Drawer';
import './ProductDetailsDrawer.css';

interface ProductDetailsDrawerProps {
    description: string | null;
}

export function ProductDetailsDrawer({ description }: ProductDetailsDrawerProps) {
    if (!description) { return null; }

    return (
        <Drawer label="product details" defaultOpen>
            <p className="pdp-product-description">{description}</p>
        </Drawer>
    );
}
